import React from 'react'

import { lazyImport } from '../utils/lazyImport'
import { HelpCenterLinking } from 'Features/HelpCenterLinking/HelpCenterLinking'

const { AuthRoutes } = lazyImport(() => import('Features/auth'), 'AuthRoutes')

export const publicRoutes = [
  {
    path: '/*',
    element: <AuthRoutes />,
  },
  {
    path: '/help-center-link/*',
    element: <HelpCenterLinking />,
  },
]
